module.exports = __webpack_public_path__ + "img/d9f9bf4.jpg";